import ModalLogin from './Modal';

export default ModalLogin;
